import config from '../../config'
import { HTTP } from  '../../http'
import moment from 'moment'

const pageSize = 50;

export function queryStringParams(request) {
    let startDate = moment(request.startDate);
    startDate.set({h: 0, m: 0, s: 0});
    let endDate = moment(request.endDate);
    endDate.set({h: 23, m: 59, s: 59});

    request.startDate = startDate.format('YYYY-MM-DDTHH:mm:ss');
    request.endDate = endDate.format('YYYY-MM-DDTHH:mm:ss');
    const eventId = request.eventId == null || request.eventId == '' ? '' : `&eventId=${request.eventId}`;
    const paymentTypeId = request.paymentTypeId == null || request.paymentTypeId == '' ? '' : `&paymentTypeId=${request.paymentTypeId}`;
    let cashierId = '';
    if(request.cashier) {
        for (let index = 0; index < request.cashier.length; index++) {
            const element = request.cashier[index];
            cashierId+= `&cashierId=${element.cid}`
        }
    }
    const userId = request.userId == null || request.userId == '' ? '' : `&userId=${request.userId}`;
    const paymentStatus = request.paymentStatus == null || request.paymentStatus == '' ? '' : `&paymentStatus=${request.paymentStatus}`;
    const operationStatus = request.operationStatus == null || request.operationStatus == '' ? '' : `&operationStatus=${request.operationStatus}`;
    const machineSerial = request.machineSerial == null || request.machineSerial == '' ? '' : `&machineSerial=${request.machineSerial}`;
    const cashierName = request.cashierName == null || request.cashierName == '' ? '' : `&cashierName=${request.cashierName}`;
    return `startDate=${request.startDate}&endDate=${request.endDate}${eventId}${paymentTypeId}${paymentStatus}${operationStatus}${cashierId}${machineSerial}${cashierName}${userId}`;
}

export function queryStringParamsWithPage(request, page, pageSize) {
    return `${queryStringParams(request)}&page=${page}&pageSize=${pageSize}`;
}

export default {
    search: (request, page) => {
        const url = `${config.apiEndpoints.barOrderReportUri}search?${queryStringParamsWithPage(request, page, pageSize)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    searchExport: (request) => {
        const url = `${config.apiEndpoints.barOrderReportUri}search/export?${queryStringParams(request)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                let blob = new Blob([response.data], { type: 'text/csv' });
                let url = window.URL.createObjectURL(blob);
                resolve(url)
            }, (error)=>{
                reject(error)
            })
        })
    },
    searchOrderItemsSummary: (request, page) => {
        const url = `${config.apiEndpoints.barOrderItemsReportUri}summary?${queryStringParamsWithPage(request, page, pageSize)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    searchOrderItemsExport: (request) => {
        const url = `${config.apiEndpoints.barOrderItemsReportUri}export?${queryStringParams(request)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                let blob = new Blob([response.data], { type: 'text/csv' });
                let url = window.URL.createObjectURL(blob);
                resolve(url)
            }, (error)=>{
                reject(error)
            })
        })
    },
    searchOrderItemsCategoriesSummary: (request, page) => {
        const url = `${config.apiEndpoints.barOrderItemCategoriesReportUri}summary?${queryStringParamsWithPage(request, page, pageSize)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    searchSummary: (request) => {
        const url = `${config.apiEndpoints.barOrderReportUri}summary?${queryStringParams(request)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getTpv: (request) => {
        const url = `${config.apiEndpoints.barOrderReportUri}tpv?${queryStringParams(request)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getTpvList: (request) => {
        const url = `${config.apiEndpoints.barOrderReportUri}tpv/list?${queryStringParams(request)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getTpvChart: (request) => {
        const url = `${config.apiEndpoints.barOrderReportUri}charts?${queryStringParams(request)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getUserSummary: (request) => {
        const url = `${config.apiEndpoints.barOrderReportUri}users/summary?${queryStringParams(request)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getCashierSummary: (request) => {
        const url = `${config.apiEndpoints.barOrderReportUri}cashiers/summary?${queryStringParams(request)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    searchAggregated: (request, page) => {
        const url = `${config.apiEndpoints.barOrderReportUri}aggregated/search?${queryStringParamsWithPage(request, page, pageSize)}`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getDetail: (vid) => {
        const url = `${config.apiEndpoints.barOrderReportUri}${vid}/detail`;
        return new Promise((resolve, reject) => {
            HTTP.get(url)
            .then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
}